import React, { useState } from 'react';

const LOGO_URL = 'https://swilshare.blob.core.windows.net/swil/companylogo-circle.png';

const Loader = () => {
  const [logoFailed, setLogoFailed] = useState(false);

  return (
    <div className="full-page-loader" role="status" aria-label="Loading SwilShare">
      <div style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div className="loader-ring"></div>
        {!logoFailed ? (
          <img
            src={LOGO_URL}
            alt="SwilShare"
            className="loader-logo"
            style={{ position: 'absolute' }}
            onError={() => setLogoFailed(true)}
          />
        ) : (
          <span className="loader-logo-fallback" style={{ position: 'absolute' }} aria-hidden="true">
            <i className="bi bi-file-earmark-pdf"></i>
          </span>
        )}
      </div>
      <p className="loader-text">Loading document…</p>
    </div>
  );
};

export default Loader;
